export default "/images/circle_active.svg?c579e5219b1f76b9ae88c37b6bc322cf";